export default {
	Menu: {
		DASHBOARD: 'Dashboard',
		OVERVIEWDASHBOARD: 'System overview',
		INVOICE: 'Input invoice',
		PROCCESS: 'Business process',
		AVADASHBOARD: 'AI Assistant - MISA AVA',
		INSTRUCTIONS: "Instructions for use",
		INVOICELIST: 'Invoice list',
		TRASHINVOICE: 'Deleted invoice',
		Received: 'Input invoice',
		// PBI-547654: Bank Audit - Conditional Labels
		INVOICETHIRDPARTY: 'Invoice',
		ReceivedThirdParty: 'Invoice',
		INBOX: 'Inbox',
		SUPPLIER: 'Category',
		OrganizationStructure: 'Organization structure',
		USER: 'Separate permissions',
		Resource: 'Resource management',
		SPAMINBOX: 'Spam mail',
		IMPORTANTINBOX: 'Important mail',
		TRASHBOX: "Trash mail",
		INBOXTO: 'Inbox',
		AuditingLog: 'Access log',
		System: 'System',
		ConnectInvoices: 'Connect to suppliers',
		ConnectTaxaxions: 'Connect Tax Authority',
		OutInvoice: 'Output invoice',
		Report: 'Report',
		ManageUser: 'User management',
		ManageRole: 'Roles & permissions',
		ManageResource: 'Resource management',
		UserSetup: "User settings",
		DiaryLogs: 'Access log',
		HistoryVatRate: 'History of tax rate acceptance',
		Options: 'Optional',
		ConnectSupplier: 'Supplier',
		Connected: 'Connected',
		ReportInvoiceRiskSupplier: 'Report invoice risk to supplier',
		ReportInvoiceBySupplierActive: 'Report invoices according to supplier performance status',
		CustomsDeclaration: 'Customs declaration',
		CustomsDeclarationTrash: 'Deleted declaration',
		CatalogSupplier: 'Supplier/Customer',
		CatalogVatRate: 'Historical Tax Rates on Goods',
		KnowledgeBase: 'Useful knowledge'
	}
};
